import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'complement-address',
  templateUrl: './address.component.html',
  styleUrls: ['./address.component.scss']
})
export class ComplementAddressComponent implements OnInit {

  constructor() { }

  @Input() template : any = 'default';
  @Input() data : {};

  ngOnInit() {
  }

}